import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import './styles.scss';
class Footer extends Component {
   render() {
        return (            
            <footer>
                <Container fluid>
                    <div className="copy-right">
                        <p>Copyright © 2019 Kobelco. All rights reserved</p>
                    </div>
                </Container>
            </footer>
        );
    }
}

export default Footer;
